// extracted by mini-css-extract-plugin
module.exports = {"location":"location-anchor-module__location___ZEqHp","image":"location-anchor-module__image___tvY77","title":"location-anchor-module__title___XE-xK"};